import { ButtonBase, ButtonBaseProps } from '@mui/material';
import { ReactNode } from 'react';

import { SizingMultiplier } from '../sizing-multiplier.constant';

type ListItemButtonProps = {
  children?: ReactNode;
  onClick?: ButtonBaseProps['onClick'];
  disableRipple?: ButtonBaseProps['disableRipple'];
  selected?: boolean;
  fullWidth?: boolean;
};

export const ListItemButton = (props: ListItemButtonProps) => {
  const { children, onClick, selected, disableRipple, fullWidth } = props;
  return (
    <ButtonBase
      onClick={onClick}
      disableRipple={disableRipple}
      sx={{
        display: 'flex',
        alignItems: 'center',
        p: SizingMultiplier.md,
        minHeight: 56,
        width: fullWidth ? '100%' : undefined,
        color: selected === false ? 'text.secondary' : 'text.primary',
      }}>
      {children}
    </ButtonBase>
  );
};
